// @flow strict

import { createContext } from 'react';
import type { Color } from '../../styled-components/Palette/Color';

export default createContext<Color>('xLight');
